import { ref } from "vue";
import { isAppReviewDialogAvailable } from "@/helpers/flutter/capabilities";
import { requestAppReview } from "@/helpers/flutter/features/in-app-review";
import { setLocalStorageItem } from "@/helpers/utils/local-storage";

const DISMISS_KEY = "appReviewDismissedAt";
const COOLDOWN_MS = 15 * 24 * 60 * 60 * 1000; // 15 days

const reviewModalVisible = ref(false);

function isDismissedRecently(): boolean {
  try {
    const stored = localStorage.getItem(DISMISS_KEY);
    if (!stored) return false;
    const dismissedAt = new Date(stored).getTime();
    if (isNaN(dismissedAt)) return false;
    return Date.now() - dismissedAt < COOLDOWN_MS;
  } catch {
    return false;
  }
}

function shouldShowReviewPrompt(): boolean {
  return isAppReviewDialogAvailable() && !isDismissedRecently();
}

export function useAppReviewPrompt() {
  function maybePromptReview(): void {
    if (shouldShowReviewPrompt()) {
      reviewModalVisible.value = true;
    }
  }

  function dismissReview(): void {
    setLocalStorageItem(DISMISS_KEY, new Date().toISOString());
    reviewModalVisible.value = false;
  }

  function acceptReview(): void {
    requestAppReview();
    setLocalStorageItem(DISMISS_KEY, new Date().toISOString());
    reviewModalVisible.value = false;
  }

  return {
    reviewModalVisible,
    maybePromptReview,
    dismissReview,
    acceptReview,
  };
}
